// Dummy database for section configurations
export const sectionTemplates = {
 hero: {
  template1: {
    id: "hero1",
    name: "Hero Template 1",
    type: "hero",
    template: "template1",
    config: {
      direction: "ltr",
      alignment: "left",

      title: "Transform Your Business with Smart Solutions",
      subtitle:
        "Streamline operations, boost productivity, and drive growth with our innovative business tools",

      buttonText: "Get Started",
      buttonLink: "/contact",

      secondaryButtonText: "",
      secondaryButtonLink: "",

      buttonVariant: "primary",

      image:
        "https://images.unsplash.com/photo-1552664730-d307ca884978?ixlib=rb-4.0.3&auto=format&fit=crop&w=1000&q=80",
      imageAlt: "Business team collaborating in a modern office",

      badgeTitle: "AI-Powered",
      badgeSubtitle: "Business Solutions",

      tagEmoji: "🚀",
      tagText: "NOW AVAILABLE",

      stats: [
        { value: "99%", label: "Client Satisfaction" },
        { value: "24/7", label: "Support" },
        { value: "3x", label: "Faster Growth" },
      ],
    },
    style: {
      bgMode: "default",
      bgColor: "",
      bgGradientFrom: "",
      bgGradientVia: "",
      bgGradientTo: "",
      bgGradientAngle: 135,

      titleColor: "#111827",
      subtitleColor: "#4B5563",

      primaryBtnBg: "#2563EB",
      primaryBtnText: "#FFFFFF",

      secondaryBtnBorder: "#D1D5DB",
      secondaryBtnText: "#374151",

      heroBadgeBg: "#FFFFFF",
      heroBadgeBorder: "rgba(0,0,0,0.08)",
      heroBadgeTitleColor: "#2563EB",
      heroBadgeSubtitleColor: "#4B5563",

      heroTagBg: "",
      heroTagBorder: "",
      heroTagTextColor: "",

      statsCardBg: "",
      statsCardBorder: "",
      statsValueColor: "",
      statsLabelColor: "",
    },
  },

  template2: {
    id: "hero2",
    name: "Hero Template 2",
    type: "hero",
    template: "template2",
    config: {
      direction: "ltr",
      alignment: "center",

      title: "Empower Your Enterprise",
      subtitle: "Cutting-edge solutions for modern businesses",

      tagEmoji: "🚀",
      tagText: "NOW AVAILABLE",

      buttonText: "Start Free Trial",
      buttonLink: "/signup",

      secondaryButtonText: "View Demo",
      secondaryButtonLink: "/demo",

      buttonVariant: "gradient",

      image:
        "https://images.unsplash.com/photo-1559136555-9303baea8ebd?ixlib=rb-4.0.3&auto=format&fit=crop&w=1000&q=80",
      imageAlt: "Modern digital dashboard and business workspace",

      badgeTitle: "AI-Powered",
      badgeSubtitle: "Business Solutions",

      stats: [
        { value: "99%", label: "Client Satisfaction" },
        { value: "24/7", label: "Support" },
        { value: "3x", label: "Faster Growth" },
      ],
    },
    style: {
      bgMode: "default",
      bgColor: "",
      bgGradientFrom: "",
      bgGradientVia: "",
      bgGradientTo: "",
      bgGradientAngle: 135,

      titleColor: "#FFFFFF",
      subtitleColor: "#DBEAFE",

      primaryBtnBg: "",
      primaryBtnText: "#FFFFFF",

      secondaryBtnBorder: "rgba(255,255,255,0.3)",
      secondaryBtnText: "#FFFFFF",

      heroBadgeBg: "",
      heroBadgeBorder: "",
      heroBadgeTitleColor: "",
      heroBadgeSubtitleColor: "",

      heroTagBg: "rgba(59,130,246,0.2)",
      heroTagBorder: "rgba(255,255,255,0.12)",
      heroTagTextColor: "#93C5FD",

      statsCardBg: "",
      statsCardBorder: "",
      statsValueColor: "",
      statsLabelColor: "",
    },
  },

  template3: {
    id: "hero3",
    name: "Hero Template 3",
    type: "hero",
    template: "template3",
    config: {
      direction: "ltr",
      alignment: "center",

      title: "Business Intelligence Redefined",
      subtitle: "Data-driven insights for strategic decision making",

      buttonText: "Learn More",
      buttonLink: "/about",

      secondaryButtonText: "Contact Us",
      secondaryButtonLink: "/contact",

      buttonVariant: "outline",

      image:
        "https://images.unsplash.com/photo-1516321318423-f06f85e504b3?auto=format&fit=crop&w=1000&q=80",
      imageAlt: "Analytics dashboard with data visualization",

      badgeTitle: "AI-Powered",
      badgeSubtitle: "Business Solutions",

      tagEmoji: "📈",
      tagText: "SMART INSIGHTS",

      stats: [
        { value: "99%", label: "Client Satisfaction" },
        { value: "24/7", label: "Support" },
        { value: "3x", label: "Faster Growth" },
      ],
    },
    style: {
      bgMode: "default",
      bgColor: "",
      bgGradientFrom: "",
      bgGradientVia: "",
      bgGradientTo: "",
      bgGradientAngle: 135,

      titleColor: "#111827",
      subtitleColor: "#4B5563",

      primaryBtnBg: "#2563EB",
      primaryBtnText: "#FFFFFF",

      secondaryBtnBorder: "#D1D5DB",
      secondaryBtnText: "#374151",

      heroBadgeBg: "",
      heroBadgeBorder: "",
      heroBadgeTitleColor: "",
      heroBadgeSubtitleColor: "",

      heroTagBg: "",
      heroTagBorder: "",
      heroTagTextColor: "",

      statsCardBg: "#F9FAFB",
      statsCardBorder: "rgba(0,0,0,0.06)",
      statsValueColor: "#2563EB",
      statsLabelColor: "#4B5563",
    },
  },
},

  features: {
  template1: {
    id: "features1",
    name: "Features Grid",
    type: "features",
    template: "template1",
    config: {
      direction: "ltr",
      badgeText: "FEATURES",
      title: "Powerful Features",
      subtitle: "Everything you need to succeed",
      buttonText: "Learn more →",
      bottomCta: {
        title: "Ready to get started?",
        subtitle: "Discover how our platform can help your business grow.",
      },
      panel: {
        bgFrom: "#111827",
        bgTo: "#000000",
        textColor: "#ffffff",
        mutedTextColor: "#d1d5db",
        statCardBg: "#ffffff",
        statCardOpacity: 0.1,
        previewEmoji: "📈",
        previewText: "Live Dashboard Preview",
        previewBgFrom: "#1f2937",
        previewBgTo: "#111827",
        stats: [
          { value: "99.9%", label: "Uptime" },
          { value: "256-bit", label: "Encryption" },
          { value: "24/7", label: "Support" },
          { value: "100+", label: "Integrations" },
        ],
      },
      floatingBadge: {
        title: "AI-Powered",
        subtitle: "Insights Engine",
        bg: "#ffffff",
        titleColor: "#2563eb",
        subtitleColor: "#4b5563",
      },
      features: [
        {
          icon: "🚀",
          title: "Automated Workflows",
          description: "Streamline processes with intelligent automation",
          benefits: [
            "Save time on repetitive tasks",
            "Reduce manual work",
            "Improve consistency",
          ],
          details:
            "Automate your recurring workflows and eliminate repetitive manual work across teams.",
          color: "from-blue-500 to-cyan-500",
          accentFrom: "#3B82F6",
          accentTo: "#06B6D4",
        },
        {
          icon: "📊",
          title: "Advanced Analytics",
          description: "Gain insights with real-time data visualization",
          benefits: [
            "Real-time dashboards",
            "Clear reporting",
            "Better decisions",
          ],
          details:
            "Monitor performance, track KPIs, and access clear visual dashboards for faster decision making.",
          color: "from-purple-500 to-pink-500",
          accentFrom: "#8B5CF6",
          accentTo: "#EC4899",
        },
        {
          icon: "🔒",
          title: "Secure Platform",
          description: "Enterprise-grade security for your data",
          benefits: [
            "Protected data",
            "Role-based access",
            "Reliable infrastructure",
          ],
          details:
            "Protect your business data with strong security controls, access management, and trusted infrastructure.",
          color: "from-green-500 to-emerald-500",
          accentFrom: "#10B981",
          accentTo: "#059669",
        },
        {
          icon: "🤖",
          title: "AI Integration",
          description: "Smart recommendations and predictions",
          benefits: [
            "Smarter suggestions",
            "Faster operations",
            "Predictive insights",
          ],
          details:
            "Use AI-powered tools to uncover opportunities, improve workflows, and support smarter business decisions.",
          color: "from-orange-500 to-amber-500",
          accentFrom: "#F97316",
          accentTo: "#F59E0B",
        },
      ],
    },
    style: {
      bgMode: "default",
      bgColor: "",
      bgGradientFrom: "",
      bgGradientVia: "",
      bgGradientTo: "",
      bgGradientAngle: 180,

      titleColor: "#111827",
      subtitleColor: "#4B5563",
      textAlign: "center",

      primaryBtnBg: "#2563EB",
      primaryBtnText: "#FFFFFF",

      featuresCardBg: "#FFFFFF",
      featuresCardBorder: "",
      featuresCardTitleColor: "#111827",
      featuresCardDescriptionColor: "#4B5563",

      featuresBadgeBg: "",
      featuresBadgeTextColor: "",
      featuresBadgeBorder: "",

      featuresCardBg2: "",
      featuresCardBorder2: "",
      featuresCardTitleColor2: "",
      featuresCardDescriptionColor2: "",
      featuresBenefitColor2: "",

      featuresBottomCtaBgFrom: "",
      featuresBottomCtaBgTo: "",
      featuresBottomCtaTitleColor: "",
      featuresBottomCtaSubtitleColor: "",

      featuresTabActiveBg: "",
      featuresTabInactiveBg: "",
      featuresTabActiveBorder: "",
      featuresTabTitleColor: "",
      featuresTabDescriptionColor: "",

      featuresFloatingBadgeBg: "",
      featuresFloatingBadgeTitleColor: "",
      featuresFloatingBadgeSubtitleColor: "",
    },
  },

  template2: {
    id: "features2",
    name: "Features Cards",
    type: "features",
    template: "template2",
    config: {
      direction: "ltr",
      badgeText: "FEATURES",
      title: "Core Capabilities",
      subtitle: "Designed for excellence and maximum impact",
      buttonText: "Learn more →",
      bottomCta: {
        title: "Built for growing teams",
        subtitle: "Scale faster with tools designed for modern businesses.",
      },
      panel: {
        bgFrom: "#111827",
        bgTo: "#000000",
        textColor: "#ffffff",
        mutedTextColor: "#d1d5db",
        statCardBg: "#ffffff",
        statCardOpacity: 0.1,
        previewEmoji: "📈",
        previewText: "Live Dashboard Preview",
        previewBgFrom: "#1f2937",
        previewBgTo: "#111827",
        stats: [
          { value: "99.9%", label: "Uptime" },
          { value: "256-bit", label: "Encryption" },
          { value: "24/7", label: "Support" },
          { value: "100+", label: "Integrations" },
        ],
      },
      floatingBadge: {
        title: "AI-Powered",
        subtitle: "Insights Engine",
        bg: "#ffffff",
        titleColor: "#2563eb",
        subtitleColor: "#4b5563",
      },
      features: [
        {
          icon: "💼",
          title: "Project Management",
          description: "Manage projects efficiently with collaborative tools",
          benefits: [
            "Real-time tracking",
            "Team collaboration",
            "Deadline management",
          ],
          details:
            "Coordinate work, track deadlines, and keep teams aligned with collaborative project tools.",
          color: "from-blue-500 to-cyan-500",
          accentFrom: "#3B82F6",
          accentTo: "#06B6D4",
        },
        {
          icon: "💰",
          title: "Financial Tracking",
          description: "Monitor expenses and revenue in real-time",
          benefits: [
            "Automated reports",
            "Budget alerts",
            "Revenue forecasting",
          ],
          details:
            "Track financial performance, forecast growth, and stay informed with automated reports and alerts.",
          color: "from-purple-500 to-pink-500",
          accentFrom: "#8B5CF6",
          accentTo: "#EC4899",
        },
        {
          icon: "👥",
          title: "Team Collaboration",
          description: "Seamless communication and file sharing",
          benefits: [
            "Instant messaging",
            "File sharing",
            "Video meetings",
          ],
          details:
            "Bring communication, collaboration, and file sharing into one connected experience for your team.",
          color: "from-green-500 to-emerald-500",
          accentFrom: "#10B981",
          accentTo: "#059669",
        },
      ],
    },
    style: {
      bgMode: "default",
      bgColor: "",
      bgGradientFrom: "",
      bgGradientVia: "",
      bgGradientTo: "",
      bgGradientAngle: 180,

      titleColor: "#111827",
      subtitleColor: "#4B5563",
      textAlign: "center",

      primaryBtnBg: "#2563EB",
      primaryBtnText: "#2563EB",

      featuresCardBg: "",
      featuresCardBorder: "",
      featuresCardTitleColor: "",
      featuresCardDescriptionColor: "",

      featuresBadgeBg: "#DBEAFE",
      featuresBadgeTextColor: "#2563EB",
      featuresBadgeBorder: "",

      featuresCardBg2: "#FFFFFF",
      featuresCardBorder2: "#E5E7EB",
      featuresCardTitleColor2: "#111827",
      featuresCardDescriptionColor2: "#4B5563",
      featuresBenefitColor2: "#374151",

      featuresBottomCtaBgFrom: "#2563EB",
      featuresBottomCtaBgTo: "#7C3AED",
      featuresBottomCtaTitleColor: "#FFFFFF",
      featuresBottomCtaSubtitleColor: "#DBEAFE",

      featuresTabActiveBg: "",
      featuresTabInactiveBg: "",
      featuresTabActiveBorder: "",
      featuresTabTitleColor: "",
      featuresTabDescriptionColor: "",

      featuresFloatingBadgeBg: "",
      featuresFloatingBadgeTitleColor: "",
      featuresFloatingBadgeSubtitleColor: "",
    },
  },

  template3: {
    id: "features3",
    name: "Features Interactive",
    type: "features",
    template: "template3",
    config: {
      direction: "ltr",
      badgeText: "FEATURES",
      title: "Enterprise-Grade Features",
      subtitle: "Everything you need to scale your business efficiently",
      buttonText: "Learn more →",
      bottomCta: {
        title: "Ready to unlock more power?",
        subtitle: "Explore advanced tools built for performance, scale, and security.",
      },
      panel: {
        bgFrom: "#111827",
        bgTo: "#000000",
        textColor: "#ffffff",
        mutedTextColor: "#d1d5db",
        statCardBg: "#ffffff",
        statCardOpacity: 0.1,
        previewEmoji: "📈",
        previewText: "Live Dashboard Preview",
        previewBgFrom: "#1f2937",
        previewBgTo: "#111827",
        stats: [
          { value: "99.9%", label: "Uptime" },
          { value: "256-bit", label: "Encryption" },
          { value: "24/7", label: "Support" },
          { value: "100+", label: "Integrations" },
        ],
      },
      floatingBadge: {
        title: "AI-Powered",
        subtitle: "Insights Engine",
        bg: "#ffffff",
        titleColor: "#2563eb",
        subtitleColor: "#4b5563",
      },
      features: [
        {
          icon: "📊",
          title: "Advanced Analytics",
          description: "Deep insights with customizable dashboards",
          details:
            "Track KPIs, generate reports, and visualize data in real-time with our powerful analytics engine.",
          benefits: [
            "Custom dashboards",
            "Clear KPI tracking",
            "Live reporting",
          ],
          color: "from-blue-500 to-cyan-500",
          accentFrom: "#3B82F6",
          accentTo: "#06B6D4",
        },
        {
          icon: "🚀",
          title: "Smart Automation",
          description: "Automate repetitive tasks and workflows",
          details:
            "Set up triggers and actions to streamline operations and reduce manual work by up to 80%.",
          benefits: [
            "Fewer manual steps",
            "Faster execution",
            "Better consistency",
          ],
          color: "from-purple-500 to-pink-500",
          accentFrom: "#8B5CF6",
          accentTo: "#EC4899",
        },
        {
          icon: "🔒",
          title: "Enterprise Security",
          description: "Military-grade encryption and compliance",
          details:
            "SOC 2 Type II certified with end-to-end encryption, role-based access, and audit logging.",
          benefits: [
            "Role-based access",
            "Encrypted systems",
            "Compliance ready",
          ],
          color: "from-green-500 to-emerald-500",
          accentFrom: "#10B981",
          accentTo: "#059669",
        },
      ],
    },
    style: {
      bgMode: "default",
      bgColor: "",
      bgGradientFrom: "",
      bgGradientVia: "",
      bgGradientTo: "",
      bgGradientAngle: 180,

      titleColor: "#111827",
      subtitleColor: "#4B5563",
      textAlign: "left",

      primaryBtnBg: "#2563EB",
      primaryBtnText: "#FFFFFF",

      featuresCardBg: "",
      featuresCardBorder: "",
      featuresCardTitleColor: "",
      featuresCardDescriptionColor: "",

      featuresBadgeBg: "",
      featuresBadgeTextColor: "",
      featuresBadgeBorder: "",

      featuresCardBg2: "",
      featuresCardBorder2: "",
      featuresCardTitleColor2: "",
      featuresCardDescriptionColor2: "",
      featuresBenefitColor2: "",

      featuresBottomCtaBgFrom: "",
      featuresBottomCtaBgTo: "",
      featuresBottomCtaTitleColor: "",
      featuresBottomCtaSubtitleColor: "",

      featuresTabActiveBg: "#EFF6FF",
      featuresTabInactiveBg: "#F9FAFB",
      featuresTabActiveBorder: "#BFDBFE",
      featuresTabTitleColor: "#111827",
      featuresTabDescriptionColor: "#4B5563",

      featuresFloatingBadgeBg: "#FFFFFF",
      featuresFloatingBadgeTitleColor: "#2563EB",
      featuresFloatingBadgeSubtitleColor: "#4B5563",
    },
  },
},

 testimonials: {
  template1: {
    id: "testimonials1",
    name: "Testimonials Grid",
    type: "testimonials",
    template: "template1",
    config: {
      direction: "ltr",
      title: "Trusted by Industry Leaders",
      subtitle: "See why businesses trust our platform to improve performance and drive growth.",
      testimonials: [
        {
          name: "Sarah Johnson",
          role: "CEO, TechCorp",
          company: "TechCorp",
          content: "SmartBusiness transformed our operations completely.",
          avatar: "SJ",
          rating: 5,
          metrics: "40% faster workflows",
        },
        {
          name: "Michael Chen",
          role: "Operations Director",
          company: "ScaleOps",
          content: "The analytics dashboard alone saved us 20 hours per week.",
          avatar: "MC",
          rating: 5,
          metrics: "20 hours saved",
        },
        {
          name: "Emma Wilson",
          role: "Marketing Director",
          company: "BrightGrowth",
          content: "Best investment we made this year. ROI in 3 months.",
          avatar: "EW",
          rating: 5,
          metrics: "ROI in 3 months",
        },
        {
          name: "James Brown",
          role: "CTO, StartupX",
          company: "StartupX",
          content: "The automation features are game-changing.",
          avatar: "JB",
          rating: 5,
          metrics: "65% productivity boost",
        },
      ],
    },
    style: {
      bgMode: "default",
      bgColor: "",
      bgGradientFrom: "",
      bgGradientVia: "",
      bgGradientTo: "",
      bgGradientAngle: 180,

      titleColor: "#111827",
      subtitleColor: "#4B5563",
      textAlign: "center",

      testimonialsCardBg: "#F9FAFB",
      testimonialsCardBorder: "#E5E7EB",

      testimonialsAvatarBg: "#DBEAFE",
      testimonialsAvatarText: "#2563EB",

      testimonialsNameColor: "#111827",
      testimonialsRoleColor: "#4B5563",
      testimonialsCompanyColor: "#6B7280",
      testimonialsContentColor: "#374151",

      testimonialsStarActiveColor: "#FACC15",
      testimonialsStarInactiveColor: "#D1D5DB",

      testimonialsQuoteIconColor: "",
      testimonialsMainCardBg: "",
      testimonialsMainCardBorder: "",
      testimonialsDotActive: "",
      testimonialsDotInactive: "",
      testimonialsNavBtnBg: "",
      testimonialsNavBtnBorder: "",
      testimonialsNavBtnIcon: "",
      testimonialsPreviewActiveBg: "",
      testimonialsPreviewActiveBorder: "",
      testimonialsPreviewCardBg: "",
      testimonialsPreviewCardBorder: "",

      testimonialsTopIconBg: "",
      testimonialsTopIconColor: "",
      testimonialsAccentBg: "",
      testimonialsAccentText: "",
      testimonialsMetricBadgeBg: "",
      testimonialsMetricBadgeText: "",
      testimonialsResultBadgeBg: "",
      testimonialsResultBadgeText: "",
    },
  },

  template2: {
    id: "testimonials2",
    name: "Testimonials Carousel",
    type: "testimonials",
    template: "template2",
    config: {
      direction: "ltr",
      title: "Customer Success Stories",
      subtitle: "Join thousands of businesses transforming their operations with our platform.",
      testimonials: [
        {
          name: "Alex Johnson",
          role: "CTO, GrowthTech",
          company: "Tech Startup",
          content:
            "SmartBusiness reduced our operational costs by 40% in the first quarter. The automation features alone saved us hundreds of hours.",
          avatar: "AJ",
          rating: 5,
          metrics: "40% cost reduction",
        },
        {
          name: "Maria Rodriguez",
          role: "Operations Manager",
          company: "Enterprise Corp",
          content:
            "The reporting dashboard gave us insights we never had before. We identified three new revenue streams within the first month.",
          avatar: "MR",
          rating: 5,
          metrics: "3 new revenue streams",
        },
        {
          name: "David Kim",
          role: "Founder & CEO",
          company: "Innovate Labs",
          content:
            "Implementation was seamless and the support team was exceptional. Our team adopted it instantly with minimal training.",
          avatar: "DK",
          rating: 5,
          metrics: "Instant team adoption",
        },
      ],
    },
    style: {
      bgMode: "default",
      bgColor: "",
      bgGradientFrom: "",
      bgGradientVia: "",
      bgGradientTo: "",
      bgGradientAngle: 180,

      titleColor: "#111827",
      subtitleColor: "#4B5563",
      textAlign: "center",

      testimonialsCardBg: "",
      testimonialsCardBorder: "",

      testimonialsAvatarBg: "#2563EB",
      testimonialsAvatarText: "#FFFFFF",

      testimonialsNameColor: "#111827",
      testimonialsRoleColor: "#2563EB",
      testimonialsCompanyColor: "#6B7280",
      testimonialsContentColor: "#1F2937",

      testimonialsStarActiveColor: "#FACC15",
      testimonialsStarInactiveColor: "#D1D5DB",

      testimonialsQuoteIconColor: "#60A5FA",

      testimonialsMainCardBg: "#FFFFFF",
      testimonialsMainCardBorder: "#E5E7EB",

      testimonialsDotActive: "#2563EB",
      testimonialsDotInactive: "#D1D5DB",

      testimonialsNavBtnBg: "#FFFFFF",
      testimonialsNavBtnBorder: "#D1D5DB",
      testimonialsNavBtnIcon: "#4B5563",

      testimonialsPreviewActiveBg: "#EFF6FF",
      testimonialsPreviewActiveBorder: "#BFDBFE",
      testimonialsPreviewCardBg: "#FFFFFF",
      testimonialsPreviewCardBorder: "#E5E7EB",

      testimonialsTopIconBg: "",
      testimonialsTopIconColor: "",
      testimonialsAccentBg: "",
      testimonialsAccentText: "",
      testimonialsMetricBadgeBg: "",
      testimonialsMetricBadgeText: "",
      testimonialsResultBadgeBg: "",
      testimonialsResultBadgeText: "",
    },
  },

  template3: {
    id: "testimonials3",
    name: "Testimonials Results",
    type: "testimonials",
    template: "template3",
    config: {
      direction: "ltr",
      title: "Proven Results",
      subtitle: "Real businesses achieving real results with SmartBusiness.",
      testimonials: [
        {
          name: "TechCorp Inc.",
          role: "Enterprise Customer",
          company: "TechCorp Inc.",
          content: "Increased productivity by 65% in the first 90 days.",
          metrics: "65% growth",
          avatar: "TC",
          rating: 5,
        },
        {
          name: "Global Finance",
          role: "Financial Services",
          company: "Global Finance",
          content: "Reduced operational costs by $2.3M annually.",
          metrics: "$2.3M saved",
          avatar: "GF",
          rating: 5,
        },
        {
          name: "Retail Giant",
          role: "Retail Chain",
          company: "Retail Giant",
          content: "Improved customer satisfaction scores by 45%.",
          metrics: "45% increase",
          avatar: "RG",
          rating: 5,
        },
      ],
    },
    style: {
      bgMode: "default",
      bgColor: "",
      bgGradientFrom: "",
      bgGradientVia: "",
      bgGradientTo: "",
      bgGradientAngle: 180,

      titleColor: "#111827",
      subtitleColor: "#4B5563",
      textAlign: "center",

      testimonialsCardBg: "#FFFFFF",
      testimonialsCardBorder: "#E5E7EB",

      testimonialsAvatarBg: "",
      testimonialsAvatarText: "",

      testimonialsNameColor: "#111827",
      testimonialsRoleColor: "#4B5563",
      testimonialsCompanyColor: "#6B7280",
      testimonialsContentColor: "#1F2937",

      testimonialsStarActiveColor: "#FACC15",
      testimonialsStarInactiveColor: "#D1D5DB",

      testimonialsQuoteIconColor: "",
      testimonialsMainCardBg: "",
      testimonialsMainCardBorder: "",
      testimonialsDotActive: "",
      testimonialsDotInactive: "",
      testimonialsNavBtnBg: "",
      testimonialsNavBtnBorder: "",
      testimonialsNavBtnIcon: "",
      testimonialsPreviewActiveBg: "",
      testimonialsPreviewActiveBorder: "",
      testimonialsPreviewCardBg: "",
      testimonialsPreviewCardBorder: "",

      testimonialsTopIconBg: "#DBEAFE",
      testimonialsTopIconColor: "#2563EB",

      testimonialsAccentBg: "#2563EB",
      testimonialsAccentText: "#FFFFFF",

      testimonialsMetricBadgeBg: "#EFF6FF",
      testimonialsMetricBadgeText: "#2563EB",

      testimonialsResultBadgeBg: "#FFFFFF",
      testimonialsResultBadgeText: "#111827",
    },
  },
},

  gallery: {
  template1: {
    id: "gallery1",
    name: "Gallery 1 - Cards + Modal",
    type: "gallery",
    template: "template1",
    config: {
      direction: "ltr",
      title: "Our Work",
      subtitle: "A selection of projects we are proud of.",
      cardButtonText: "View Project Details",
      modalPrimaryButtonText: "View Live Project",
      modalOverviewTitle: "Project Overview",
      modalFeaturesTitle: "Key Features",
      modalFeatures: [
        "Responsive design for all devices",
        "Performance optimization",
        "Search engine friendly structure",
        "Secure data handling",
      ],
      stats: [
        { value: "12+", label: "Completed Projects" },
        { value: "50+", label: "Happy Clients" },
        { value: "24/7", label: "Support" },
        { value: "98%", label: "Client Retention" },
      ],
      projects: [
        {
          id: "p1",
          title: "Project One",
          category: "Web",
          image:
            "https://images.unsplash.com/photo-1521737604893-d14cc237f11d?auto=format&fit=crop&w=1200&q=80",
          description: "Short description for the project.",
          url: "https://example.com",
          results: [
            { value: "300%", label: "Revenue Increase" },
            { value: "40 hours", label: "Time Saved per Week" },
            { value: "98%", label: "Client Satisfaction" },
          ],
        },
        {
          id: "p2",
          title: "Project Two",
          category: "Branding",
          image:
            "https://images.unsplash.com/photo-1516321318423-f06f85e504b3?auto=format&fit=crop&w=1200&q=80",
          description: "A creative branding and digital identity project.",
          url: "https://example.com",
          results: [
            { value: "120%", label: "Engagement Growth" },
            { value: "2x", label: "Lead Conversion" },
            { value: "95%", label: "Client Satisfaction" },
          ],
        },
      ],
    },
    style: {
      bgMode: "default",
      bgColor: "",
      bgGradientFrom: "",
      bgGradientVia: "",
      bgGradientTo: "",
      bgGradientAngle: 180,

      alignment: "center",
      textAlign: "center",

      titleColor: "#111827",
      subtitleColor: "#4B5563",
      primaryBtnBg: "#2563EB",
      primaryBtnText: "#FFFFFF",

      galleryCardBg: "#FFFFFF",
      galleryCardBorder: "#E5E7EB",
      galleryCardTitleColor: "#111827",
      galleryCardDescriptionColor: "#4B5563",
      galleryOverlayColor: "rgba(0,0,0,0.65)",

      galleryStatsCardBg: "#FFFFFF",
      galleryStatsCardBorder: "#E5E7EB",
      galleryStatsValueColor: "#2563EB",
      galleryStatsLabelColor: "#4B5563",

      galleryModalBg: "#FFFFFF",
      galleryModalTitleColor: "#111827",
      galleryModalCategoryColor: "#2563EB",
      galleryModalTextColor: "#4B5563",
      galleryModalFeatureBoxBg: "#F9FAFB",
      galleryModalFeatureBoxBorder: "#E5E7EB",
      galleryModalFeatureTitleColor: "#111827",
      galleryModalFeatureTextColor: "#374151",

      gallerySecondaryBtnBg: "#FFFFFF",
      gallerySecondaryBtnBorder: "#D1D5DB",
      gallerySecondaryBtnText: "#374151",

      galleryFilterActiveBg: "",
      galleryFilterActiveText: "",
      galleryFilterInactiveBg: "",
      galleryFilterInactiveText: "",
      galleryFilterInactiveBorder: "",

      galleryOverlayTextColor: "",
      galleryEmptyStateColor: "",

      galleryMainTextColor: "",
      galleryBadgeBg: "",
      galleryBadgeTextColor: "",
      galleryResultCardBg: "",
      galleryResultCardBorder: "",
      galleryResultValueColor: "",
      galleryResultLabelColor: "",
      galleryMoreProjectsLabelColor: "",
      galleryThumbActiveBorder: "",
      galleryThumbOverlayColor: "",
    },
  },

  template2: {
    id: "gallery2",
    name: "Gallery 2 - Masonry + Filters",
    type: "gallery",
    template: "template2",
    config: {
      direction: "ltr",
      title: "Portfolio",
      subtitle: "Browse by category.",
      emptyStateText: "No projects in this category yet.",
      filterButtons: [
        { id: "all", label: "All" },
        { id: "Web", label: "Web" },
        { id: "Mobile", label: "Mobile" },
        { id: "Branding", label: "Branding" },
      ],
      projects: [
        {
          id: "p1",
          title: "Project One",
          category: "Web",
          image:
            "https://images.unsplash.com/photo-1551288049-bebda4e38f71?auto=format&fit=crop&w=1200&q=80",
          description: "Short description for the project.",
          url: "https://example.com",
          results: [
            { value: "300%", label: "Revenue Increase" },
            { value: "40 hours", label: "Time Saved per Week" },
            { value: "98%", label: "Client Satisfaction" },
          ],
        },
        {
          id: "p2",
          title: "Mobile Product",
          category: "Mobile",
          image:
            "https://images.unsplash.com/photo-1512941937669-90a1b58e7e9c?auto=format&fit=crop&w=1200&q=80",
          description: "A mobile-first product with a modern experience.",
          url: "https://example.com",
          results: [
            { value: "2.5x", label: "Downloads Growth" },
            { value: "4.9/5", label: "User Rating" },
            { value: "87%", label: "Retention Rate" },
          ],
        },
        {
          id: "p3",
          title: "Brand Identity",
          category: "Branding",
          image:
            "https://images.unsplash.com/photo-1545239351-1141bd82e8a6?auto=format&fit=crop&w=1200&q=80",
          description: "A strong visual identity and communication system.",
          url: "https://example.com",
          results: [
            { value: "180%", label: "Brand Reach" },
            { value: "3x", label: "Audience Growth" },
            { value: "96%", label: "Client Satisfaction" },
          ],
        },
      ],
    },
    style: {
      bgMode: "default",
      bgColor: "",
      bgGradientFrom: "",
      bgGradientVia: "",
      bgGradientTo: "",
      bgGradientAngle: 180,

      alignment: "center",
      textAlign: "center",

      titleColor: "#111827",
      subtitleColor: "#4B5563",
      primaryBtnBg: "#2563EB",
      primaryBtnText: "#FFFFFF",

      galleryFilterActiveBg: "#2563EB",
      galleryFilterActiveText: "#FFFFFF",
      galleryFilterInactiveBg: "#F3F4F6",
      galleryFilterInactiveText: "#374151",
      galleryFilterInactiveBorder: "#E5E7EB",

      galleryOverlayColor: "rgba(0,0,0,0.75)",
      galleryOverlayTextColor: "#FFFFFF",
      galleryEmptyStateColor: "#6B7280",

      galleryCardBg: "",
      galleryCardBorder: "",
      galleryCardTitleColor: "",
      galleryCardDescriptionColor: "",

      galleryStatsCardBg: "",
      galleryStatsCardBorder: "",
      galleryStatsValueColor: "",
      galleryStatsLabelColor: "",

      galleryModalBg: "",
      galleryModalTitleColor: "",
      galleryModalCategoryColor: "",
      galleryModalTextColor: "",
      galleryModalFeatureBoxBg: "",
      galleryModalFeatureBoxBorder: "",
      galleryModalFeatureTitleColor: "",
      galleryModalFeatureTextColor: "",

      gallerySecondaryBtnBg: "",
      gallerySecondaryBtnBorder: "",
      gallerySecondaryBtnText: "",

      galleryMainTextColor: "",
      galleryBadgeBg: "",
      galleryBadgeTextColor: "",
      galleryResultCardBg: "",
      galleryResultCardBorder: "",
      galleryResultValueColor: "",
      galleryResultLabelColor: "",
      galleryMoreProjectsLabelColor: "",
      galleryThumbActiveBorder: "",
      galleryThumbOverlayColor: "",
    },
  },

  template3: {
    id: "gallery3",
    name: "Gallery 3 - Featured Slider",
    type: "gallery",
    template: "template3",
    config: {
      direction: "ltr",
      title: "Our Work",
      subtitle: "Featured projects and results.",
      primaryButtonText: "View Live Project",
      moreProjectsLabel: "More Projects",
      emptyStateText: "No projects yet. Add projects from the admin editor.",
      projects: [
        {
          id: "p1",
          title: "Featured Project",
          category: "Web Development",
          image:
            "https://images.unsplash.com/photo-1556742049-0cfed4f6a45d?auto=format&fit=crop&w=1200&q=80",
          description: "Short description for the project.",
          url: "https://example.com",
          results: [
            { value: "300%", label: "Revenue Increase" },
            { value: "40 hours", label: "Time Saved per Week" },
            { value: "98%", label: "Client Satisfaction" },
          ],
        },
        {
          id: "p2",
          title: "Growth Campaign",
          category: "Marketing",
          image:
            "https://images.unsplash.com/photo-1460925895917-afdab827c52f?auto=format&fit=crop&w=1200&q=80",
          description: "A high-performing campaign with measurable results.",
          url: "https://example.com",
          results: [
            { value: "220%", label: "Lead Increase" },
            { value: "35%", label: "Cost Reduction" },
            { value: "91%", label: "Conversion Rate Improvement" },
          ],
        },
        {
          id: "p3",
          title: "Mobile Experience",
          category: "Mobile",
          image:
            "https://images.unsplash.com/photo-1511707171634-5f897ff02aa9?auto=format&fit=crop&w=1200&q=80",
          description: "A fast and polished app experience for modern users.",
          url: "https://example.com",
          results: [
            { value: "4.9/5", label: "App Rating" },
            { value: "2x", label: "Engagement" },
            { value: "88%", label: "Retention Rate" },
          ],
        },
      ],
      featuredProjects: [],
    },
    style: {
      bgMode: "default",
      bgColor: "",
      bgGradientFrom: "",
      bgGradientVia: "",
      bgGradientTo: "",
      bgGradientAngle: 135,

      alignment: "center",
      textAlign: "center",

      titleColor: "#FFFFFF",
      subtitleColor: "#D1D5DB",
      primaryBtnBg: "#2563EB",
      primaryBtnText: "#FFFFFF",

      galleryMainTextColor: "#E5E7EB",
      galleryBadgeBg: "#2563EB",
      galleryBadgeTextColor: "#FFFFFF",

      galleryResultCardBg: "rgba(255,255,255,0.08)",
      galleryResultCardBorder: "rgba(255,255,255,0.12)",
      galleryResultValueColor: "#60A5FA",
      galleryResultLabelColor: "#9CA3AF",

      galleryMoreProjectsLabelColor: "#9CA3AF",
      galleryThumbActiveBorder: "#2563EB",
      galleryThumbOverlayColor: "rgba(0,0,0,0.3)",
      galleryEmptyStateColor: "#D1D5DB",

      galleryCardBg: "",
      galleryCardBorder: "",
      galleryCardTitleColor: "",
      galleryCardDescriptionColor: "",
      galleryOverlayColor: "",
      galleryStatsCardBg: "",
      galleryStatsCardBorder: "",
      galleryStatsValueColor: "",
      galleryStatsLabelColor: "",
      galleryModalBg: "",
      galleryModalTitleColor: "",
      galleryModalCategoryColor: "",
      galleryModalTextColor: "",
      galleryModalFeatureBoxBg: "",
      galleryModalFeatureBoxBorder: "",
      galleryModalFeatureTitleColor: "",
      galleryModalFeatureTextColor: "",
      gallerySecondaryBtnBg: "",
      gallerySecondaryBtnBorder: "",
      gallerySecondaryBtnText: "",
      galleryFilterActiveBg: "",
      galleryFilterActiveText: "",
      galleryFilterInactiveBg: "",
      galleryFilterInactiveText: "",
      galleryFilterInactiveBorder: "",
      galleryOverlayTextColor: "",
    },
  },
},

 categorysection: {
  template1: {
    id: "category1",
    name: "Category Demo Grid",
    type: "categorysection",
    template: "template1",
    config: {
      direction: "ltr",
      title: "Demo Products",
      subtitle: "A quick preview of what you will find in the catalog",
      catalogId: "YOUR_CATALOG_ID",
      baseUrl: "https://smartcatalog.shop",
      buttonText: "Open Full Catalog",
      hintText: "You are seeing a few demo items only",
      maxItems: 6,

      fallbackItemTitle: "Untitled item",
      featuredBadgeText: "Featured",
      fallbackFeaturedTitle: "Featured item",
      viewInCatalogText: "View in catalog",
      demoItemsLabel: "Demo items shown",

      items: [
        {
          id: "demo-1",
          title: "Featured Item",
          subtitle: "Short description goes here",
          image:
            "https://images.unsplash.com/photo-1523275335684-37898b6baf30?auto=format&fit=crop&w=1400&q=80",
        },
        {
          id: "demo-2",
          title: "Second Item",
          subtitle: "Another short line",
          image:
            "https://images.unsplash.com/photo-1526170375885-4d8ecf77b99f?auto=format&fit=crop&w=1400&q=80",
        },
        {
          id: "demo-3",
          title: "Third Item",
          subtitle: "Demo preview item",
          image:
            "https://images.unsplash.com/photo-1542291026-7eec264c27ff?auto=format&fit=crop&w=1400&q=80",
        },
      ],

      itemsJson: JSON.stringify(
        [
          {
            id: "demo-1",
            title: "Featured Item",
            subtitle: "Short description goes here",
            image:
              "https://images.unsplash.com/photo-1523275335684-37898b6baf30?auto=format&fit=crop&w=1400&q=80",
          },
          {
            id: "demo-2",
            title: "Second Item",
            subtitle: "Another short line",
            image:
              "https://images.unsplash.com/photo-1526170375885-4d8ecf77b99f?auto=format&fit=crop&w=1400&q=80",
          },
          {
            id: "demo-3",
            title: "Third Item",
            subtitle: "Demo preview item",
            image:
              "https://images.unsplash.com/photo-1542291026-7eec264c27ff?auto=format&fit=crop&w=1400&q=80",
          },
        ],
        null,
        2
      ),
    },
    style: {
      bgMode: "default",
      bgColor: "",
      bgGradientFrom: "",
      bgGradientVia: "",
      bgGradientTo: "",
      bgGradientAngle: 180,

      alignment: "center",
      textAlign: "center",

      titleColor: "#111827",
      subtitleColor: "#4B5563",
      primaryBtnBg: "#2563EB",
      primaryBtnText: "#FFFFFF",

      categoryCardBg: "#FFFFFF",
      categoryCardBorder: "#E5E7EB",
      categoryCardTitleColor: "#111827",
      categoryCardSubtitleColor: "#4B5563",
      categoryImageOverlayColor: "linear-gradient(to top, rgba(0,0,0,0.40), transparent)",
      categoryLinkColor: "#2563EB",

      categoryFeaturedBadgeBg: "",
      categoryFeaturedBadgeText: "",
      categoryFeaturedBadgeBorder: "",
      categoryFeaturedPanelBg: "",
      categoryFeaturedPanelBorder: "",
      categoryMetricBoxBg: "",
      categoryMetricBoxBorder: "",
      categoryMetricLabelColor: "",
      categoryMetricValueColor: "",
    },
  },

  template2: {
    id: "category2",
    name: "Category Carousel Demo",
    type: "categorysection",
    template: "template2",
    config: {
      direction: "ltr",
      title: "Popular Picks",
      subtitle: "Swipe through a few demo items",
      catalogId: "YOUR_CATALOG_ID",
      baseUrl: "https://smartcatalog.shop",
      buttonText: "Open Catalog",
      hintText: "Tap any card to open the catalog",
      maxItems: 8,

      fallbackItemTitle: "Untitled item",
      featuredBadgeText: "Featured",
      fallbackFeaturedTitle: "Featured item",
      viewInCatalogText: "Tap to open in catalog",
      demoItemsLabel: "Demo items shown",

      items: [
        {
          id: "demo-1",
          title: "Featured Item",
          subtitle: "Short description goes here",
          image:
            "https://images.unsplash.com/photo-1523275335684-37898b6baf30?auto=format&fit=crop&w=1400&q=80",
        },
        {
          id: "demo-2",
          title: "Second Item",
          subtitle: "Another short line",
          image:
            "https://images.unsplash.com/photo-1526170375885-4d8ecf77b99f?auto=format&fit=crop&w=1400&q=80",
        },
        {
          id: "demo-3",
          title: "Third Item",
          subtitle: "Demo preview item",
          image:
            "https://images.unsplash.com/photo-1542291026-7eec264c27ff?auto=format&fit=crop&w=1400&q=80",
        },
      ],

      itemsJson: JSON.stringify(
        [
          {
            id: "demo-1",
            title: "Featured Item",
            subtitle: "Short description goes here",
            image:
              "https://images.unsplash.com/photo-1523275335684-37898b6baf30?auto=format&fit=crop&w=1400&q=80",
          },
          {
            id: "demo-2",
            title: "Second Item",
            subtitle: "Another short line",
            image:
              "https://images.unsplash.com/photo-1526170375885-4d8ecf77b99f?auto=format&fit=crop&w=1400&q=80",
          },
          {
            id: "demo-3",
            title: "Third Item",
            subtitle: "Demo preview item",
            image:
              "https://images.unsplash.com/photo-1542291026-7eec264c27ff?auto=format&fit=crop&w=1400&q=80",
          },
        ],
        null,
        2
      ),
    },
    style: {
      bgMode: "default",
      bgColor: "",
      bgGradientFrom: "",
      bgGradientVia: "",
      bgGradientTo: "",
      bgGradientAngle: 135,

      alignment: "center",
      textAlign: "center",

      titleColor: "#111827",
      subtitleColor: "#4B5563",
      primaryBtnBg: "#2563EB",
      primaryBtnText: "#FFFFFF",

      categoryCardBg: "#FFFFFF",
      categoryCardBorder: "#E5E7EB",
      categoryCardTitleColor: "#FFFFFF",
      categoryCardSubtitleColor: "rgba(255,255,255,0.80)",
      categoryImageOverlayColor: "linear-gradient(to top, rgba(0,0,0,0.50), transparent)",
      categoryLinkColor: "#2563EB",

      categoryFeaturedBadgeBg: "",
      categoryFeaturedBadgeText: "",
      categoryFeaturedBadgeBorder: "",
      categoryFeaturedPanelBg: "",
      categoryFeaturedPanelBorder: "",
      categoryMetricBoxBg: "",
      categoryMetricBoxBorder: "",
      categoryMetricLabelColor: "",
      categoryMetricValueColor: "",
    },
  },

  template3: {
    id: "category3",
    name: "Category Spotlight Demo",
    type: "categorysection",
    template: "template3",
    config: {
      direction: "ltr",
      title: "Featured Preview",
      subtitle: "Spotlight item plus a short list of other demo items",
      catalogId: "YOUR_CATALOG_ID",
      baseUrl: "https://smartcatalog.shop",
      buttonText: "Go to Full Catalog",
      hintText: "This section is a preview only",
      maxItems: 6,

      fallbackItemTitle: "Untitled item",
      featuredBadgeText: "Featured",
      fallbackFeaturedTitle: "Featured item",
      viewInCatalogText: "View in catalog",
      demoItemsLabel: "Demo items shown",

      items: [
        {
          id: "demo-1",
          title: "Featured Item",
          subtitle: "Short description goes here",
          image:
            "https://images.unsplash.com/photo-1523275335684-37898b6baf30?auto=format&fit=crop&w=1400&q=80",
        },
        {
          id: "demo-2",
          title: "Second Item",
          subtitle: "Another short line",
          image:
            "https://images.unsplash.com/photo-1526170375885-4d8ecf77b99f?auto=format&fit=crop&w=1400&q=80",
        },
        {
          id: "demo-3",
          title: "Demo preview item",
          subtitle: "More items shown in catalog",
          image:
            "https://images.unsplash.com/photo-1542291026-7eec264c27ff?auto=format&fit=crop&w=1400&q=80",
        },
      ],

      itemsJson: JSON.stringify(
        [
          {
            id: "demo-1",
            title: "Featured Item",
            subtitle: "Short description goes here",
            image:
              "https://images.unsplash.com/photo-1523275335684-37898b6baf30?auto=format&fit=crop&w=1400&q=80",
          },
          {
            id: "demo-2",
            title: "Second Item",
            subtitle: "Another short line",
            image:
              "https://images.unsplash.com/photo-1526170375885-4d8ecf77b99f?auto=format&fit=crop&w=1400&q=80",
          },
          {
            id: "demo-3",
            title: "Demo preview item",
            subtitle: "More items shown in catalog",
            image:
              "https://images.unsplash.com/photo-1542291026-7eec264c27ff?auto=format&fit=crop&w=1400&q=80",
          },
        ],
        null,
        2
      ),
    },
    style: {
      bgMode: "default",
      bgColor: "",
      bgGradientFrom: "",
      bgGradientVia: "",
      bgGradientTo: "",
      bgGradientAngle: 180,

      alignment: "left",
      textAlign: "left",

      titleColor: "#111827",
      subtitleColor: "#4B5563",
      primaryBtnBg: "#2563EB",
      primaryBtnText: "#FFFFFF",

      categoryCardBg: "#FFFFFF",
      categoryCardBorder: "#E5E7EB",
      categoryCardTitleColor: "#111827",
      categoryCardSubtitleColor: "#4B5563",
      categoryImageOverlayColor:
        "linear-gradient(to top, rgba(0,0,0,0.60), rgba(0,0,0,0.10), transparent)",
      categoryLinkColor: "#2563EB",

      categoryFeaturedBadgeBg: "rgba(255,255,255,0.15)",
      categoryFeaturedBadgeText: "#FFFFFF",
      categoryFeaturedBadgeBorder: "rgba(255,255,255,0.25)",

      categoryFeaturedPanelBg: "#FFFFFF",
      categoryFeaturedPanelBorder: "#E5E7EB",

      categoryMetricBoxBg: "#FFFFFF",
      categoryMetricBoxBorder: "#E5E7EB",
      categoryMetricLabelColor: "#6B7280",
      categoryMetricValueColor: "#111827",
    },
  },
},


cta: {
  template1: {
    id: "cta1",
    name: "CTA Form (Simple)",
    type: "cta",
    template: "template1",
    config: {
      direction: "ltr",

      title: "Let's Start a Conversation",
      subtitle: "Send us your details on WhatsApp and we will get back to you quickly.",

      nameLabel: "Full Name",
      namePlaceholder: "John Doe",

      phoneLabel: "Phone Number",
      phonePlaceholder: "9725...",

      messageLabel: "Message",
      messagePlaceholder: "Tell us what you need...",

      privacyText: "When you click send, your message will open in WhatsApp.",

      buttonText: "Send via WhatsApp",

      successTitle: "Opening WhatsApp...",
      successSubtitle: "Your message is ready to send.",

      businessPhone: "",
      whatsappNumber: "",
    },
    style: {
      bgMode: "solid",
      bgColor: "#F9FAFB",
      bgGradientFrom: "",
      bgGradientVia: "",
      bgGradientTo: "",
      bgGradientAngle: 180,

      textAlign: "center",

      titleColor: "#111827",
      subtitleColor: "#4B5563",

      primaryBtnBg: "#16A34A",
      primaryBtnText: "#FFFFFF",

      ctaCardBg: "#FFFFFF",
      ctaCardBorder: "#E5E7EB",

      ctaInputBg: "#FFFFFF",
      ctaInputBorder: "#D1D5DB",
      ctaInputText: "#111827",
      ctaInputLabelColor: "#374151",

      ctaSuccessIconBg: "#DCFCE7",
      ctaSuccessIconColor: "#16A34A",
      ctaSuccessTitleColor: "#111827",
      ctaSuccessSubtitleColor: "#4B5563",

      ctaMutedTextColor: "#6B7280",

      ctaPanelBg: "",
      ctaPanelBorder: "",
      ctaInfoCardBg: "",
      ctaInfoCardBorder: "",
      ctaBadgeBg: "",
      ctaBadgeText: "",
      ctaBadgeBorder: "",
      ctaFooterBarBg: "",
      ctaFooterTextColor: "",
      ctaTabActiveBg: "",
      ctaTabActiveText: "",
      ctaTabInactiveBg: "",
      ctaTabInactiveText: "",
      ctaTabBorder: "",
      ctaQuickItemBg: "",
      ctaQuickItemBorder: "",
      ctaQuickItemText: "",
      ctaAccentBg: "",
      ctaAccentText: "",
      ctaAccentBorder: "",
      ctaInfoTitleColor: "",
      ctaInfoTextColor: "",
      ctaInfoNoteColor: "",
      ctaMetricCardBg: "",
      ctaMetricCardBorder: "",
      ctaMetricValueColor: "",
      ctaMetricLabelColor: "",
    },
  },

  template2: {
    id: "cta2",
    name: "CTA Multi-Channel (WhatsApp/Phone)",
    type: "cta",
    template: "template2",
    config: {
      direction: "ltr",

      badgeText: "Connect With Us 24/7",

      title: "Get in Touch Instantly",
      subtitle: "Choose your preferred way to connect with our team. We're here to help!",

      tabWhatsApp: "WhatsApp",
      tabWhatsAppHint: "Instant reply",
      tabPhone: "Call Us",
      tabPhoneHint: "Talk to us directly",

      buttonText: "Send via WhatsApp",

      successTitle: "Opening WhatsApp...",
      successSubtitle: "Your message is ready to send",

      whatsappFormTitle: "WhatsApp Business",
      whatsappCardTitle: "WhatsApp Business",
      whatsappCardSubtitle: "Typically replies within minutes",
      whatsappStartText: "Open WhatsApp",
      whatsappFooterLine: "Mobile and web supported",

      namePlaceholder: "Your Name",
      phonePlaceholder: "Your Phone Number",
      messagePlaceholder: "How can we help you?",

      phoneTitle: "Call Our Support Team",
      phoneHours: "We are available during business hours",
      phoneCallNowText: "Call Us Now",
      phoneRatesText: "Call the business directly",

      footerStats: ["Global support", "Fast replies", "Secure and private"],
      trustBadges: ["⭐ Trusted service", "🔒 Private", "⚡ Fast support", "💬 WhatsApp available"],

      whatsappTemplates: [
        "I'm interested in your services",
        "I'd like a demo",
        "I have a question about pricing",
        "Support needed",
      ],

      businessPhone: "",
      whatsappNumber: "",
    },
    style: {
      bgMode: "gradient",
      bgColor: "",
      bgGradientFrom: "#16A34A",
      bgGradientVia: "#2563EB",
      bgGradientTo: "#1E3A8A",
      bgGradientAngle: 135,

      textAlign: "center",

      titleColor: "#FFFFFF",
      subtitleColor: "rgba(255,255,255,0.9)",

      primaryBtnBg: "#16A34A",
      primaryBtnText: "#FFFFFF",

      ctaCardBg: "#FFFFFF",
      ctaCardBorder: "#E5E7EB",

      ctaInputBg: "#FFFFFF",
      ctaInputBorder: "#D1D5DB",
      ctaInputText: "#111827",
      ctaInputLabelColor: "#374151",

      ctaSuccessIconBg: "#DCFCE7",
      ctaSuccessIconColor: "#16A34A",
      ctaSuccessTitleColor: "#111827",
      ctaSuccessSubtitleColor: "#4B5563",

      ctaMutedTextColor: "#6B7280",

      ctaPanelBg: "#F0FDF4",
      ctaPanelBorder: "#BBF7D0",

      ctaInfoCardBg: "#F9FAFB",
      ctaInfoCardBorder: "#E5E7EB",

      ctaBadgeBg: "rgba(255,255,255,0.18)",
      ctaBadgeText: "#FFFFFF",
      ctaBadgeBorder: "rgba(255,255,255,0.20)",

      ctaFooterBarBg: "#F9FAFB",
      ctaFooterTextColor: "#4B5563",

      ctaTabActiveBg: "#EFF6FF",
      ctaTabActiveText: "#2563EB",
      ctaTabInactiveBg: "#F9FAFB",
      ctaTabInactiveText: "#6B7280",
      ctaTabBorder: "#E5E7EB",

      ctaQuickItemBg: "#FFFFFF",
      ctaQuickItemBorder: "#D1D5DB",
      ctaQuickItemText: "#374151",

      ctaAccentBg: "#16A34A",
      ctaAccentText: "#FFFFFF",
      ctaAccentBorder: "",

      ctaInfoTitleColor: "#111827",
      ctaInfoTextColor: "#16A34A",
      ctaInfoNoteColor: "#6B7280",

      ctaMetricCardBg: "",
      ctaMetricCardBorder: "",
      ctaMetricValueColor: "",
      ctaMetricLabelColor: "",
    },
  },

  template3: {
    id: "cta3",
    name: "CTA Contact Hub (WhatsApp & Phone)",
    type: "cta",
    template: "template3",
    config: {
      direction: "ltr",

      title: "Get in Touch",
      subtitle: "Choose your preferred way to connect with our team.",

      tabWhatsAppLabel: "WhatsApp Us",
      tabPhoneLabel: "Call Us",

      formNamePlaceholder: "Your Name",
      formPhonePlaceholder: "Your Phone Number",
      formMessagePlaceholder: "Your Message",

      buttonText: "Send via WhatsApp",

      successTitle: "Opening WhatsApp...",
      successSubtitle: "Your message is ready to send",

      whatsappCardTitle: "WhatsApp",
      whatsappCardValue: "Chat with us",
      whatsappCardNote: "Fast replies on WhatsApp",

      phoneCardTitle: "Phone",
      phoneCardValue: "Call us directly",
      phoneCardNote: "Business contact number",

      officeCardTitle: "Office",
      officeCardValue: "Business address here",

      phonePanelTitle: "Call our team",
      phonePanelSubtitle: "Use the business phone number below",
      phoneWaitText: "We will be happy to help you",
      phoneCallNowText: "Call Now",
      phoneIntlText: "This will call the business phone from the page settings.",

      metric1Label: "WhatsApp Support",
      metric1Value: "Fast",
      metric2Label: "Phone Access",
      metric2Value: "Direct",

      businessPhone: "",
      whatsappNumber: "",
    },
    style: {
      bgMode: "solid",
      bgColor: "#F9FAFB",
      bgGradientFrom: "",
      bgGradientVia: "",
      bgGradientTo: "",
      bgGradientAngle: 180,

      textAlign: "left",

      titleColor: "#111827",
      subtitleColor: "#4B5563",

      primaryBtnBg: "#16A34A",
      primaryBtnText: "#FFFFFF",

      ctaCardBg: "#FFFFFF",
      ctaCardBorder: "#E5E7EB",

      ctaInputBg: "#FFFFFF",
      ctaInputBorder: "#D1D5DB",
      ctaInputText: "#111827",
      ctaInputLabelColor: "#374151",

      ctaSuccessIconBg: "#DCFCE7",
      ctaSuccessIconColor: "#16A34A",
      ctaSuccessTitleColor: "#111827",
      ctaSuccessSubtitleColor: "#4B5563",

      ctaMutedTextColor: "#6B7280",

      ctaPanelBg: "#F0FDF4",
      ctaPanelBorder: "#BBF7D0",

      ctaInfoCardBg: "#FFFFFF",
      ctaInfoCardBorder: "#E5E7EB",

      ctaBadgeBg: "",
      ctaBadgeText: "",
      ctaBadgeBorder: "",

      ctaFooterBarBg: "",
      ctaFooterTextColor: "",

      ctaTabActiveBg: "#EFF6FF",
      ctaTabActiveText: "#2563EB",
      ctaTabInactiveBg: "#FFFFFF",
      ctaTabInactiveText: "#6B7280",
      ctaTabBorder: "#2563EB",

      ctaQuickItemBg: "",
      ctaQuickItemBorder: "",
      ctaQuickItemText: "",

      ctaAccentBg: "#DBEAFE",
      ctaAccentText: "#2563EB",
      ctaAccentBorder: "",

      ctaInfoTitleColor: "#111827",
      ctaInfoTextColor: "#4B5563",
      ctaInfoNoteColor: "#6B7280",

      ctaMetricCardBg: "#FFFFFF",
      ctaMetricCardBorder: "#E5E7EB",
      ctaMetricValueColor: "#111827",
      ctaMetricLabelColor: "#6B7280",
    },
  },
},
  // service section configuration for your database
serviceSection: {
  template1: {
    id: "service1",
    name: "Service 1 - Clean Grid with Icons",
    type: "serviceSection",
    template: "template1",
    config: {
      direction: "ltr",
      alignment: "center",

      title: "Our Services",
      subtitle: "Comprehensive solutions tailored to your business needs",

      viewAllText: "View All Services",
      viewAllLink: "/services",

      additionalInfo: "Choose the service that matches your current business goals.",
      customQuoteLink: "/contact",

      services: [
        {
          id: 1,
          title: "Consulting Services",
          description: "Expert advice and strategic guidance to help your business grow.",
          fullDescription:
            "Our consulting service helps businesses improve operations, identify new opportunities, and build a stronger long-term growth plan.",
          icon: "💡",
          image:
            "https://images.unsplash.com/photo-1552664730-d307ca884978?auto=format&fit=crop&w=1350&q=80",
          features: ["Strategic Planning", "Market Analysis", "Growth Strategy"],
          link: "/services/consulting",
          buttonLink: "/services/consulting",
          buttonIcon: "",
          badge: "Popular",
          price: "From $2,500",
          duration: "2-4 weeks",
          name: "Consulting Services",
          period: "/month",
          limitations: [],
          highlighted: false,
          popular: false,
        },
        {
          id: 2,
          title: "Professional Training",
          description: "Comprehensive training programs to develop your team's skills and expertise.",
          fullDescription:
            "Our training programs help your team improve practical skills, adopt better workflows, and work more effectively together.",
          icon: "📚",
          image:
            "https://images.unsplash.com/photo-1516321318423-f06f85e504b3?auto=format&fit=crop&w=1350&q=80",
          features: ["Workshops", "Online Courses", "Certification"],
          link: "/services/training",
          buttonLink: "/services/training",
          buttonIcon: "",
          badge: "",
          price: "From $1,200",
          duration: "1-2 weeks",
          name: "Professional Training",
          period: "/month",
          limitations: [],
          highlighted: false,
          popular: false,
        },
        {
          id: 3,
          title: "Support and Maintenance",
          description: "Reliable ongoing support to keep your operations running smoothly.",
          fullDescription:
            "Stay focused on your business while we provide ongoing support, updates, and issue resolution when needed.",
          icon: "🔧",
          image:
            "https://images.unsplash.com/photo-1454165804606-c3d57bc86b40?auto=format&fit=crop&w=1350&q=80",
          features: ["Always available", "Regular Updates", "Priority Response"],
          link: "/services/support",
          buttonLink: "/services/support",
          buttonIcon: "",
          badge: "",
          price: "From $499",
          duration: "Ongoing",
          name: "Support and Maintenance",
          period: "/month",
          limitations: [],
          highlighted: false,
          popular: false,
        },
      ],
    },
    style: {
      bgMode: "default",
      bgColor: "",
      bgGradientFrom: "",
      bgGradientVia: "",
      bgGradientTo: "",
      bgGradientAngle: 135,

      textAlign: "center",
      alignment: "center",

      titleColor: "#111827",
      subtitleColor: "#4B5563",

      primaryBtnBg: "#2563EB",
      primaryBtnText: "#FFFFFF",

      serviceCardBg: "#FFFFFF",
      serviceCardBorder: "#E5E7EB",

      serviceBadgeBg: "#DBEAFE",
      serviceBadgeTextColor: "#2563EB",
      serviceBadgeBorder: "",

      serviceIconBg: "",
      serviceIconColor: "",

      serviceCardTitleColor: "#111827",
      serviceCardDescriptionColor: "#4B5563",

      serviceFeatureTextColor: "#374151",
      serviceFeatureIconColor: "#10B981",

      serviceLinkColor: "#2563EB",

      servicePanelBg: "",
      servicePanelBorder: "",
      serviceImageOverlayColor: "",
      serviceMetaTextColor: "",
      serviceMutedTextColor: "#6B7280",
      servicePriceColor: "",
      serviceNavBtnBg: "",
      serviceNavBtnBorder: "",
      serviceNavBtnIcon: "",
      serviceDotActive: "",
      serviceDotInactive: "",

      servicePricingToggleBg: "",
      servicePricingToggleActiveBg: "",
      servicePricingToggleActiveText: "",
      servicePricingToggleInactiveText: "",
      serviceHighlightedRing: "",
      servicePopularBadgeBg: "",
      servicePopularBadgeText: "",
      servicePeriodColor: "",
      serviceXIconColor: "",
      serviceLimitationsColor: "",
      serviceSecondaryBtnBg: "",
      serviceSecondaryBtnText: "",
      serviceSecondaryBtnBorder: "",
    },
  },

  template2: {
    id: "service2",
    name: "Service 2 - Carousel with Images",
    type: "serviceSection",
    template: "template2",
    config: {
      direction: "ltr",
      alignment: "center",

      title: "How We Help Your Business",
      subtitle: "Explore our comprehensive range of business solutions",

      viewAllText: "View All Services",
      viewAllLink: "/services",

      additionalInfo: "Flexible solutions designed for different business stages.",
      customQuoteLink: "/contact",

      services: [
        {
          id: 1,
          title: "Business Consulting",
          description: "Strategic guidance to optimize operations.",
          fullDescription:
            "Our experienced consultants work closely with your team to identify opportunities, streamline processes, and implement solutions that deliver measurable results.",
          icon: "💼",
          image:
            "https://images.unsplash.com/photo-1552664730-d307ca884978?auto=format&fit=crop&w=1350&q=80",
          price: "From $2,500",
          duration: "2-4 weeks",
          link: "/services/consulting",
          buttonLink: "/services/consulting",
          buttonIcon: "",
          features: ["Market Analysis", "Process Optimization", "Growth Strategy"],
          badge: "",
          name: "Business Consulting",
          period: "/month",
          limitations: [],
          highlighted: false,
          popular: false,
        },
        {
          id: 2,
          title: "Digital Transformation",
          description: "Modernize systems and processes for better results.",
          fullDescription:
            "We help businesses adopt modern tools, upgrade internal systems, and improve workflows to support long-term growth.",
          icon: "🚀",
          image:
            "https://images.unsplash.com/photo-1551434678-e076c223a692?auto=format&fit=crop&w=1350&q=80",
          price: "Custom pricing",
          duration: "3-6 months",
          link: "/services/transformation",
          buttonLink: "/services/transformation",
          buttonIcon: "",
          features: ["Technology Audit", "System Integration", "Digital Strategy"],
          badge: "",
          name: "Digital Transformation",
          period: "/month",
          limitations: [],
          highlighted: false,
          popular: false,
        },
        {
          id: 3,
          title: "Operational Support",
          description: "Ongoing support to keep business systems reliable.",
          fullDescription:
            "Our support team helps reduce downtime, improve response times, and keep your business operations moving smoothly.",
          icon: "🛠️",
          image:
            "https://images.unsplash.com/photo-1454165804606-c3d57bc86b40?auto=format&fit=crop&w=1350&q=80",
          price: "From $799",
          duration: "Ongoing",
          link: "/services/support",
          buttonLink: "/services/support",
          buttonIcon: "",
          features: ["Monitoring", "Issue Resolution", "Regular Improvements"],
          badge: "",
          name: "Operational Support",
          period: "/month",
          limitations: [],
          highlighted: false,
          popular: false,
        },
      ],
    },
    style: {
      bgMode: "gradient",
      bgColor: "",
      bgGradientFrom: "#F9FAFB",
      bgGradientVia: "",
      bgGradientTo: "#FFFFFF",
      bgGradientAngle: 135,

      textAlign: "center",
      alignment: "center",

      titleColor: "#111827",
      subtitleColor: "#4B5563",

      primaryBtnBg: "#2563EB",
      primaryBtnText: "#FFFFFF",

      serviceCardBg: "",
      serviceCardBorder: "",

      serviceBadgeBg: "",
      serviceBadgeTextColor: "",
      serviceBadgeBorder: "",

      serviceIconBg: "",
      serviceIconColor: "",

      serviceCardTitleColor: "#111827",
      serviceCardDescriptionColor: "#4B5563",

      serviceFeatureTextColor: "#374151",
      serviceFeatureIconColor: "#10B981",

      serviceLinkColor: "",
      servicePanelBg: "#FFFFFF",
      servicePanelBorder: "#E5E7EB",
      serviceImageOverlayColor: "",
      serviceMetaTextColor: "#2563EB",
      serviceMutedTextColor: "#6B7280",
      servicePriceColor: "#111827",

      serviceNavBtnBg: "#FFFFFF",
      serviceNavBtnBorder: "#E5E7EB",
      serviceNavBtnIcon: "#4B5563",

      serviceDotActive: "#2563EB",
      serviceDotInactive: "#D1D5DB",

      servicePricingToggleBg: "",
      servicePricingToggleActiveBg: "",
      servicePricingToggleActiveText: "",
      servicePricingToggleInactiveText: "",
      serviceHighlightedRing: "",
      servicePopularBadgeBg: "",
      servicePopularBadgeText: "",
      servicePeriodColor: "",
      serviceXIconColor: "",
      serviceLimitationsColor: "",
      serviceSecondaryBtnBg: "",
      serviceSecondaryBtnText: "",
      serviceSecondaryBtnBorder: "",
    },
  },

  template3: {
    id: "service3",
    name: "Service 3 - Pricing Table",
    type: "serviceSection",
    template: "template3",
    config: {
      direction: "ltr",
      alignment: "center",

      title: "Simple, Transparent Pricing",
      subtitle: "Choose the plan that's right for your business",

      viewAllText: "View All Services",
      viewAllLink: "/services",

      additionalInfo: "All plans include a 14-day free trial. No credit card required.",
      customQuoteLink: "/contact",

      services: [
        {
          id: 1,
          name: "Starter",
          title: "Starter",
          description: "Perfect for small businesses just getting started",
          price: {
            monthly: "$29",
            yearly: "$290",
            onetime: "$499",
          },
          period: "/month",
          features: ["Up to 5 users", "Basic analytics", "Email support"],
          limitations: ["No custom branding"],
          buttonText: "Start Free Trial",
          buttonLink: "/signup/starter",
          buttonIcon: "",
          popular: false,
          highlighted: false,
          icon: "🌱",
          image: "",
          duration: "",
          link: "/signup/starter",
          badge: "",
          fullDescription:
            "A solid starting point for businesses that need essential tools and a simple setup.",
        },
        {
          id: 2,
          name: "Professional",
          title: "Professional",
          description: "Ideal for growing businesses with advanced needs",
          price: {
            monthly: "$79",
            yearly: "$790",
            onetime: "$1299",
          },
          period: "/month",
          features: ["Up to 20 users", "Advanced analytics", "Priority support", "Custom branding"],
          limitations: [],
          buttonText: "Choose Professional",
          buttonLink: "/signup/professional",
          buttonIcon: "",
          popular: true,
          highlighted: true,
          icon: "🚀",
          image: "",
          duration: "",
          link: "/signup/professional",
          badge: "Popular",
          fullDescription:
            "Best for growing teams that need stronger analytics, branding flexibility, and priority support.",
        },
        {
          id: 3,
          name: "Enterprise",
          title: "Enterprise",
          description: "For large organizations with custom requirements",
          price: {
            monthly: "$199",
            yearly: "$1990",
            onetime: "Custom",
          },
          period: "/month",
          features: ["Unlimited users", "Custom analytics", "24/7 support", "Dedicated account manager"],
          limitations: [],
          buttonText: "Contact Sales",
          buttonLink: "/contact",
          buttonIcon: "",
          popular: false,
          highlighted: false,
          icon: "🏢",
          image: "",
          duration: "",
          link: "/contact",
          badge: "",
          fullDescription:
            "Enterprise support and custom setup for large teams with advanced business requirements.",
        },
      ],
    },
    style: {
      bgMode: "default",
      bgColor: "#F9FAFB",
      bgGradientFrom: "",
      bgGradientVia: "",
      bgGradientTo: "",
      bgGradientAngle: 135,

      textAlign: "center",
      alignment: "center",

      titleColor: "#111827",
      subtitleColor: "#4B5563",

      primaryBtnBg: "#2563EB",
      primaryBtnText: "#FFFFFF",

      serviceCardBg: "#FFFFFF",
      serviceCardBorder: "#E5E7EB",

      serviceBadgeBg: "",
      serviceBadgeTextColor: "",
      serviceBadgeBorder: "",

      serviceIconBg: "",
      serviceIconColor: "",

      serviceCardTitleColor: "#111827",
      serviceCardDescriptionColor: "#4B5563",

      serviceFeatureTextColor: "#374151",
      serviceFeatureIconColor: "#10B981",

      serviceLinkColor: "#2563EB",
      servicePanelBg: "",
      servicePanelBorder: "",
      serviceImageOverlayColor: "",
      serviceMetaTextColor: "",
      serviceMutedTextColor: "#6B7280",
      servicePriceColor: "#111827",

      serviceNavBtnBg: "",
      serviceNavBtnBorder: "",
      serviceNavBtnIcon: "",
      serviceDotActive: "",
      serviceDotInactive: "",

      servicePricingToggleBg: "#FFFFFF",
      servicePricingToggleActiveBg: "#2563EB",
      servicePricingToggleActiveText: "#FFFFFF",
      servicePricingToggleInactiveText: "#6B7280",

      serviceHighlightedRing: "#2563EB",
      servicePopularBadgeBg: "#2563EB",
      servicePopularBadgeText: "#FFFFFF",

      servicePeriodColor: "#6B7280",
      serviceXIconColor: "#9CA3AF",
      serviceLimitationsColor: "#9CA3AF",

      serviceSecondaryBtnBg: "#F3F4F6",
      serviceSecondaryBtnText: "#111827",
      serviceSecondaryBtnBorder: "#E5E7EB",
    },
  },
},
  // add this inside sectionTemplates (same level as hero, features, footersection...)
navsection: {
  template1: {
    name: "Nav 1 - Sticky Menu",
    config: {
      enabled: true,
      sticky: true,

      // ✅ NEW
      direction: "ltr",
      alignment: "left", // left | center | right

      brandName: "My Business",
      brandLogo: "",

      links: [
        { label: "Home", href: "/{slug}" },
        { label: "Contact", href: "#contact" },
      ],

      showManagerLogin: true,
      loginButtonText: "Login",

      // keep this
      managerTargetRoute: "/{slug}/manager",
      // (optional) new key (if you want)
      // loginTargetRoute: "/{slug}/manager",
    },
    style: {
      bgColor: "#0B1220",
      textColor: "#FFFFFF",
      linkColor: "#CBD5E1",
      buttonBgColor: "#FFFFFF",
      buttonTextColor: "#0B1220",
      borderColor: "rgba(255,255,255,0.12)",
    },
  },
},

  footersection: {
    template1: {
      name: "Footer 1 - Modern Business Footer",
      config: {
        direction: "ltr",

        businessName: "My Business",
        businessDescription: "Short description about the business and what it offers.",
        businessLogo: "",

        addressLine1: "123 Main Street",
        addressLine2: "",
        city: "New York",
        country: "USA",

        phone: "+1 (555) 123-4567",
        email: "hello@business.com",

        socials: [
          { id: 1, type: "instagram", url: "https://instagram.com" },
          { id: 2, type: "facebook", url: "https://facebook.com" },
          { id: 3, type: "whatsapp", url: "wa:+15551234567" },
        ],

        privacyLinkText: "Privacy Policy",
        privacyTitle: "Privacy Policy",
        privacyUpdatedAt: "Last updated: 2026-02-16",
        privacyContent:
          "Write your privacy policy here.\n\nYou can use multiple paragraphs by adding empty lines.",

        developedByText: "Developed by",
        developerName: "Your Name or Company",
        developerWebsite: "https://example.com",
        developerLogo: "",
      },
      style: {
        bgMode: "solid",
        bgColor: "#0B1220",
        titleColor: "#FFFFFF",
        subtitleColor: "#B6C2D1",
        primaryBtnBg: "#2563EB",
        primaryBtnText: "#FFFFFF",
        linkColor: "#93C5FD",
        dividerColor: "rgba(255,255,255,0.12)",
      },
    },
  },
};

export const pageConfig = {
  businessPage: {
    nav: {
      enabled: true,
      template: "template1",
      config: {},
      style: {},
    },
    sections: [
      {
        id: 'section1',
        type: 'hero',
        template: 'template1',
        enabled: true
      },
      {
        id: 'section2',
        type: 'features',
        template: 'template1',
        enabled: true
      },
      {
        id: 'section3',
        type: 'testimonials',
        template: 'template1',
        enabled: true
      },
      {
        id: 'section5',
        type: 'cta',
        template: 'template1',
        enabled: true
      }
    ]
  }
};

// Helper function to get section component
export const getSectionComponent = (type, template) => {
  return sectionTemplates[type]?.[template] || null;
};